<div class="modal-header">
  <h4 class="modal-title">Compare persisted message</h4>  
</div>
<div class="modal-body">
  <ng-container *ngIf="loading">
    <div class="text-center py-3">
      <div class="spinner-border spinner-border-sm me-2" role="status"></div>
      Loading comparison...
    </div>
  </ng-container>

  <ng-container *ngIf="error">
    <div class="alert alert-danger">{{ error }}</div>
  </ng-container>

  <ng-container *ngIf="!loading && !error && result !== null">
    @if (!result.hasDifferences) {
      <div class="alert alert-success mb-0">No differences found.</div>
    } @else {
      <kendo-grid [data]="result.differences" [scrollable]="'none'">
        <kendo-grid-column field="propertyPath" title="Property"></kendo-grid-column>        
        <kendo-grid-column field="previousValue" title="Previous value">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="text-danger font-monospace">{{ formatValue(dataItem.previousValue) }}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="currentValue" title="Current value">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="text-success font-monospace">{{ formatValue(dataItem.currentValue) }}</span>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    }
  </ng-container>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close()">Close</button>
</div>
